import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import { inject, observer } from 'mobx-react'
import config from 'react-global-configuration';

import { Section, Text, Link, GridRow, withColor, BiggerText, Heading1 } from '../marketing/MarketingStyles';

import { Arrow } from '../../images/icons/Icons';

@inject('utilStore', 'translationStore')
@observer
class PressSection extends Component {

  constructor(props) {
    super(props)
    this.state = {
      index: 0
    }
  }

  render() {

    const { press, isPhone, isTablet } = this.props.utilStore

    // if(press.length <= 2 && !isPhone) {
    //   press.push({ isPlaceholder: true })
    // }

    const newIndex = !isTablet ? this.state.index + 1 : this.state.index

    const hasNext = press && isTablet ? newIndex < press.length - 1 : newIndex < press.length - 2
    const hasPrev = press && isTablet ? newIndex > 0 : newIndex > 1

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    return (
      <SectionWrapper id="press">
        <Heading1>{ text('marketing_press_headline') }</Heading1>
        <BiggerText>
          { text('marketing_press_subheadline') }
        </BiggerText>

        <NavigationWrapper>
          <NavigationButton enabled={hasPrev} onClick={ () => hasPrev ? this.setState( { index: this.state.index - 1 } ) : '' }><Arrow size="2em" rotation="180deg" /></NavigationButton>
          <NavigationButton enabled={hasNext} onClick={ () => hasNext ? this.setState( { index: this.state.index + 1 } ) : '' }><Arrow size="2em" /></NavigationButton>
        </NavigationWrapper>
        <PressCarousel
          key="press-carousel"
          centerMode centerSlidePercentage={ isTablet ? "100" : "33.3" } showArrows={false} autoPlay={false} showStatus={false} showIndicators={false} showThumbs={false}
          onChange={ index => this.setState( { index: !isTablet ? index - 1 : index } ) }
          selectedItem={ newIndex }
        >
          { press && press.map((item, index) => {
            return item.isPlaceholder ?
              <div></div>
              :
              <PressCard key={'press' + index}>
                <GridRow
                  desktop="1fr 1fr"
                  tablet="1fr" tabletRowGap
                  style={{ height: '100%' }}
                >
                  <PressImage src={`${config.get('DIRECTUS_BACKEND')}assets/${ item.logo.id }?key=medium`} alt="" />
                  <PressCardContent>
                    <Text>{ item.text }</Text>
                    <CardText>{ item.name } am { item.date && new Date(item.date).toLocaleDateString("de-AT") }</CardText>
                    <CardLink target="_blank" href={
                      item.file ? `${config.get('DIRECTUS_BACKEND')}assets/${ item.file.id }` : item.link
                    }>WEITER LESEN</CardLink>
                  </PressCardContent>
                </GridRow>
              </PressCard>
          })}
        </PressCarousel>
      </SectionWrapper>
    )
  }
}

export default PressSection

const PressCarousel = styled(Carousel) `
  margin: 0 -10px;

  .slide {
    max-width: 33.3%;
  }
`

const SectionWrapper = styled(Section) `
  ${cssVar.breakpoints.tablet} {
    display: flex;
    flex-direction: column;
  }
`

const PressCard = styled.div `
  background: ${ cssVar.colors.lightest_grey };
  margin: 0 10px;
  padding: 20px 10px;
  height: 100%
`

const PressImage = styled.img `
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 10px;

  ${cssVar.breakpoints.tablet} {
    height: 150px;
  }
`

const PressCardContent = styled.div `
  display: flex;
  flex-direction: column;
  text-align: left;

  ${cssVar.breakpoints.tablet} {
    text-align: center;
  }
`

const NavigationWrapper = styled.div `
  text-align: right;
  padding: 0 0 20px 0;
  order: 10;

  ${cssVar.breakpoints.tablet} {
    display: grid;
    padding: 20px 0;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
  }
`

const NavigationButton = styled.div `
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 10px calc(20px - 1em) 10px 20px;
  border: 2px solid ${props => props.enabled ? cssVar.colors.blue : cssVar.colors.grey};
  color: ${props => props.enabled ? cssVar.colors.blue : cssVar.colors.grey};
  border-radius: 2px;
  cursor: ${props => props.enabled ? 'pointer' : 'not-allowed'};

  text-align: center;

  :not(:last-child) {
    margin-right: 20px;
  }

  ${cssVar.breakpoints.tablet} {
    width: 100%;
  }
`

const CardText = styled(Text) `
  flex: 1;
  align-items: flex-start;
  color: ${ cssVar.colors.grey }
`

const CardLink = withColor(Link, cssVar.colors.grey)



// WEBPACK FOOTER //
// /src/components/marketing/PressSection.js